// Difficulty tier 2 (medium). See easy_templates.js for the format/derivation
// notes — geometry is auto-derived and sections chain via a height offset, so
// there is no startsHigh/endsHigh metadata.
export const mediumTemplates = {
  spikes2: {
    layout: `
....SSS......SSS......SSS.....
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  pits2: {
    layout: `
BBBBB....BBBB....BBBB....BBBBB
BBBBB....BBBB....BBBB....BBBBB
`,
    metadata: {},
  },
  raised_platform2: {
    layout: `
.........BBBB....BBBB.........
..............................
..............................
BBBB......................BBBB
BBBB......................BBBB
`,
    metadata: {},
  },

  jumping2: {
    layout: `
.....BBBB....BBBB....BBBB.....
..............................
..SSSSSSSSSSSSSSSSSSSSSSSSSS..
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  lasers2: {
    layout: `
..............L...............
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  projectiles2: {
    layout: `
..BB......................pB..
..BB......................pB..
..BB......................pB..
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  stair_up2: {
    layout: `
......................BBBBBBBB
..............................
.................BBB..........
..............................
............BBB...............
..............................
.......BBB....................
..............................
BBBBB.........................
BBBBB.........................
`,
    metadata: {},
  },

  stair_down2: {
    layout: `
BBBBBBBB......................
..........S...................
..........BBB.................
..............................
...............BBB............
..............................
....................BBB.......
..............................
.........................BBBBB
.........................BBBBB
`,
    metadata: {},
  },
  projectile_stairs_up2: {
    layout: `
..BB..................BBBBBBBB
..BB..................BBBBBBBB
..BB.............BBBBBBBBBBBBB
..BB.............pBBBBBBBBBBBB
............BBBBBBBBBBBBBBBBBB
............BBBBBBBBBBBBBBBBBB
.......BBBBBBBBBBBBBBBBBBBBBBB
.......BBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  projectile_stair_down2: {
    layout: `
BBBBBBBB...................BB.
BBBBBBBB...................pB.
BBBBBBBBBBBBB..............BB.
BBBBBBBBBBBBB..............BB.
BBBBBBBBBBBBBBBBBB............
BBBBBBBBBBBBBBBBBB............
BBBBBBBBBBBBBBBBBBBBBBB.......
BBBBBBBBBBBBBBBBBBBBBBB.......
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  // A recessed crossing with a stepping platform (see sunk_platform1).
  sunk_platform2: {
    layout: `
.....SS.......................
BBBBBBB.................BBBBBB
BBBBBBB.................BBBBBB
BBBBBBB.....BBBBBBB.....BBBBBB
BBBBBBB.................BBBBBB
`,
    metadata: {},
  },

  // A solid-floored laser maze: navigate the gaps between the wall segments
  // while timing the two beams. The full floor means it stays solid when raised.
  raised_lasers2: {
    layout: `
...........L...........L......
BBB...BBBBBBBBBBBBBBBBBB...BBB
BBB...BBBBBBBBBBBBBBBBBB...BBB
BBB...BBBBBBBBBBBBBBB......BBB
BBB...BBBBBBBBBBBBBBB......BBB
BBB...BBBBBBBBBBBBBBB...BBBBBB
BBB...BBBBBBBBBBBB......BBBBBB
BBB...BBBBBBBBBBBB......BBBBBB
BBB...BBBBBBBBBBBB...BBBBBBBBB
BBB..................BBBBBBBBB
BBB..................BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Medium ramps: +3 / -3 with a spike on the step edge to time. Like the easy
  // step ramps, these let terrain settle at intermediate heights.
  step_up2: {
    layout: `
..................SS..........
..................BBBBBBBBBBBB
..................BBBBBBBBBBBB
..................BBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  step_down2: {
    layout: `
........SSSS..................
BBBBBBBBBBBB..................
BBBBBBBBBBBB..................
BBBBBBBBBBBB..................
BBBBBBBBBBBBBBBBBBBBBBBB...BBB
BBBBBBBBBBBBBBBBBBBBBBBB...BBB
`,
    metadata: {},
  },

  // Platform-assisted mid climbs/descents: hop a floating stepping stone from
  // the low floor up to a higher exit plateau (or the reverse). The gaps between
  // are the hazard. A +6/-6 change — between the small step ramps and the full
  // staircases.
  raised_platform_up2: {
    layout: `
.......................BBBBBBB
.......................BBBBBBB
.......................BBBBBBB
..........BBBBBBBB.....BBBBBBB
.......................BBBBBBB
.......................BBBBBBB
BBBBB..................BBBBBBB
BBBBB..................BBBBBBB
`,
    metadata: {},
  },
  raised_platform_down2: {
    layout: `
BBBBBBB.......................
BBBBBBB.......................
BBBBBBB.......................
BBBBBBB.....BBBBBBBB..........
BBBBBBB.......................
BBBBBBB.......................
BBBBBBB..................BBBBB
BBBBBBB..................BBBBB
`,
    metadata: {},
  },

  // Projectile gauntlets that don't stay on one plane: dodge the turret, then
  // climb the step out higher (up) — or drop in from a high ledge and run the
  // gauntlet down to a lower exit (down). Turrets fire left into a backstop.
  projectile_up2: {
    layout: `
..S...........................
..B...................pBBBBBBB
..B...................pBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectile_down2: {
    layout: `
BBBBBB........................
BBBBBB................S.......
BBBBBB................pBBBBBBB
BBBBBB................pBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Wall-jump climb (+9) to a higher plateau — taller than wall_climb1, with a
  // spike to clear on the run-in and a spike planted on the exit ledge so the
  // final wall-jump has to land clean. See the wall-jump notes in
  // easy_templates.js for the shaft geometry and the contentTopRow override.
  wall_climb2: {
    layout: `
.............BBBB.............
.............BBBB.............
.............BBBB.............
.............BBBB.........S...
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.....S...............BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 10 },
  },

  // wall_climb_wide2 (+8): a wider 5-cell shaft — the longer carry across the
  // gap makes each wall-jump less forgiving — with spikes on the run-in and the
  // exit ledge. See the wall-jump notes in easy_templates.js.
  wall_climb_wide2: {
    layout: `
............BBBB..............
............BBBB..............
............BBBB..............
............BBBB..............
............BBBB..........S...
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
............BBBB.....BBBBBBBBB
.....S...............BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 9 },
  },

  // wall_descent2 (-7): ride the wall down the shaft, then a spike sits just past
  // the doorway so the exit has to be timed, not rushed. See wall_descent1/3 for
  // the descent shape and the contentTopRow rationale.
  wall_descent2: {
    layout: `
..............BBB.............
..............BBB.............
..............BBB.............
..............BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB........S...........
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 8 },
  },

  // HORIZONTAL laser (`l`) test: a thin beam runs left-to-right between two
  // floating blocks (the enclosure — a `B` immediately left and right of the
  // `l` run), pulsing on the shared laser phase. Spikes below force a jump and
  // the beam sits in the jump arc directly above them, so clear it while the
  // beam is off. Vertical `L` is unchanged; this exercises the new lowercase
  // horizontal variant.
  hlaser1: {
    layout: `
.........B..........B.........
.........BllllllllllB.........
.............SS...............
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // VERTICAL projectile (`P`) test: a down-firing turret hung from a ceiling
  // mount. Time your run underneath so no round is mid-drop as you pass — the
  // bullets fall to the floor (splatting on it) or are despawned past the
  // bottom. Uppercase `P` fires down; lowercase `p` is the left-firing turret.
  vproj1: {
    layout: `
.............BBB..............
..............P...............
..............................
..............................
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
};
